module.exports = __webpack_public_path__ + "static/media/myBodyBackLogo.5a6eb559.svg";